import { ContentCard } from '../../../components/ContentCard/ContentCard';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsImageContentCard.css';
import { CmsMeta } from '../cmsMeta';

type CmsImageContentCardProps = {
	imageSrc: string;
	markupContent: string;
};
export const CmsImageContentCard = ({ markupContent, imageSrc }: CmsImageContentCardProps): JSX.Element => {
	return (
		<>
			<div className="cms-image-content-card">
				<div className="banner">
					<img src={imageSrc} />
				</div>
				<div className="content-text">
					<ContentCard>
						<SanitizedHtml html={markupContent} />
					</ContentCard>
				</div>
			</div>
		</>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A picture beside a card of text - side by side on desktop, stacked on mobile - for presenting one product or package on a campaign page. `markupContent` takes simple html, usually an <h1> and a paragraph or list.',
	example: [
		'CmsImageContentCard',
		{
			imageSrc: 'https://cdn.ondio.com/assets/14e57f0fcab746a0921eebd4be9d1b85.jpg',
			markupContent:
				'<h1>Kompakt arbetsplats med Leitz Ergo</h1><p>Paketet för dig som vill ha en ergonomisk arbetsplats med möjlighet till rörelse genom ett höj- och sänkbart skrivbord och pall.</p>',
		},
	],
};
